export default "__VITE_ASSET__Dh4Zi6N1__"